module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3048926480/src/~/core-js/library/modules/_add-to-unscopables.js
// module id = cq/B
// module chunks = 6